import { RollingNumber } from './RollingNumber';

interface ProfitLineProps {
  /** Positive delta — caller is expected to have already checked
   *  `computeProfit` is > 0 before mounting this. */
  profit: number;
  /** Defer the inline odometer until the line is on screen —
   *  see `RollingNumber.start`. */
  roll: boolean;
  /** Returning view — render the profit value as static text with no
   *  roll. Forwarded to the inner `RollingNumber`. */
  instant?: boolean;
}

/**
 * Big two-tone "PROFIT +$X.XX" line — Figma 729:19511. Word
 * "PROFIT" inherits `--co-WinnerStepProfit-labelColor`; amount
 * uses `--co-WinnerStepProfit-valueColor` (brand-green by default).
 */
export function ProfitLine({ profit, roll, instant = false }: ProfitLineProps) {
  return (
    <span
      data-co-component="WinnerStepProfit"
      className="font-bold uppercase tracking-[-0.6px]"
      style={{
        color: 'var(--co-WinnerStepProfit-labelColor, #FFFFFF)',
        fontFamily:
          'var(--co-WinnerStepProfit-font, "Inter"), Inter, sans-serif',
        fontSize: 'var(--co-WinnerStepProfit-size, 44px)',
        lineHeight: '56px',
      }}
    >
      Profit{' '}
      <span
        style={{
          color:
            'var(--co-WinnerStepProfit-valueColor, var(--color-brand-primary, #22E11C))',
        }}
      >
        +$<RollingNumber value={profit} start={roll} instant={instant} />
      </span>
    </span>
  );
}
